import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';
import IttAppBar from '../../components/app/IttAppBar';
import { captureNhStyleFingerprintsView } from '../../utils/engageNhStyleFingerprintAnalytics';

function NhStyleFingerprintShell() {
  useEffect(() => {
    captureNhStyleFingerprintsView();
  }, []);

  return (
    <>
      <IttAppBar title="NH style fingerprints" />
      <Container sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </>
  );
}

export default NhStyleFingerprintShell;
